import { Tag } from "../../../../common/components/common/Tag/Tag";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { EventType, UserEventStatus } from "../../../../common/enums";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { dateUtility } from "../../../../common/infrastructure/utilities/dateUtility";
import { bg } from "date-fns/locale";
import { EventTypeLabels } from "../../../../common/labels";
import { IMyReservationsViewModel } from "../models/MyReservationsViewModel";
import styles from "./ReservationItem.module.scss";
import { classNames } from "primereact/utils";
import { getStatus } from "../../../planner/event/utils/PlannerEventStatusUtility";

interface IReservationItemProps {
  item?: IMyReservationsViewModel;
  isLoading: boolean;
  isHeadOfFamily: boolean;
  onClick: (newId: number) => void;
}

export const ReservationItem = ({
  item,
  isLoading,
  isHeadOfFamily,
  onClick,
}: IReservationItemProps) => {
  const typeOfeventDetails =
    EventTypeLabels[item?.eventDetails.type ?? EventType.Group];

  const {
    color: statusColor,
    label: statusLabel,
    additionalTag,
  } = getStatus(
    item?.eventDetails.isPassed ?? true,
    item?.status,
    item?.isCancelled,
    item?.pricePaid,
  );

  return (
    <div
      className={classNames(styles.root)}
      onClick={() =>
        item?.reservationId ? onClick(item?.reservationId!) : () => {}
      }
    >
        <div className={styles.root_left_section}>
          <SkeletonItem
            isLoading={isLoading}
            width={200}
            value={
              <div className={styles.root_left_section_title}>
                {item?.eventDetails.name}
                <span className={styles.root_left_section_title_subtitle}>
                  {typeOfeventDetails}
                </span>
              </div>
            }
          />
          <SkeletonItem
            isLoading={isLoading}
            width={300}
            value={
              <div
                className={classNames(
                  styles.root_left_section_item,
                  styles.root_left_section_item_sub,
                )}
              >
                <RenderWhen
                  condition={
                    !item?.eventDetails.isPassed &&
                    (item?.status === UserEventStatus.Confirmed ||
                      item?.status === UserEventStatus.Pending)
                  }
                >
                  <Tag
                    backgroundColor={"#8082f0ff"}
                    className={styles.tag}
                    label={
                      item?.eventDetails.type === EventType.Service
                        ? "Бъдеща резервация"
                        : "Бъдещ клас"
                    }
                  />
                </RenderWhen>
                <RenderWhen condition={!!isHeadOfFamily}>
                  <Tag className={styles.tag} label={item?.userName ?? ""} />
                </RenderWhen>
                <Tag
                  backgroundColor={"#f5aa89"}
                  label={
                    <span className={styles.tag}>
                      {dateUtility.formatDate(
                        item?.eventDetails.date,
                        "EEEE, dd.MM.yyyy",
                        bg,
                      )}
                      {item?.eventDetails.startTime
                        ? ` в ${item.eventDetails.startTime}`
                        : ""}
                    </span>
                  }
                />
                <Tag
                  label={statusLabel}
                  className={classNames(styles.tag)}
                  backgroundColor={statusColor}
                />
                <RenderWhen condition={!!additionalTag}>
                  <Tag
                    label={additionalTag?.label ?? ""}
                    className={classNames(styles.tag)}
                    backgroundColor={additionalTag?.color ?? ""}
                  />
                </RenderWhen>

                <RenderWhen condition={!!item?.visitsUsed}>
                  <Tag
                    backgroundColor={"#b4c9ff"}
                    label={
                      <span className={styles.tag}>
                        Поредно посещение: {item?.visitsUsed}/
                        {item?.initialPlanVisits}
                      </span>
                    }
                  />
                </RenderWhen>

                {/* <RenderWhen condition={!!paymentTypeLabel}>
                  <Tag
                    className={styles.tag}
                    label={paymentTypeLabel!}
                    backgroundColor="#e7e7ef"
                    fontColor={"#000"}
                  />
                </RenderWhen> */}
              </div>
            }
          />
        </div>
        <div className={styles.root_right_section}>
          <Icon type={IconType.RightChevronIcon} />
        </div>
      </div>
  );
};
